import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';


import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

/**
 * Generated class for the CompieComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'compie',
  templateUrl: 'compie.html'
})
export class CompieComponent {

  text: string;
  
  diasres;

  licencias;


  constructor(
    private alertController: AlertController,
      	public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variablesglobales:VariablesProvider
  	) {





}


abrirWA(texto: string) {
  const url = 'https://wa.me/34630438995?text=' + encodeURIComponent(texto);
  window.open(url, '_blank');
}


async solicitar() {
  try {
     this.funciones.solicitarrenovacion(this.variablesglobales.username).then((data) => {

    if (data["RESULTADO"] == "OK") {
      this.variablesglobales.licenciaestado = "solicitada_renovacion";

      const alert =  this.alertController.create({
        subTitle: 'Aviso',
        message: '<b>Solicitud de renovación recibida.</b><br><br>Su proveedor se pondrá en contacto con Usted para<br>completar el proceso de renovación.<br><br>Gracias por renovar con nosotros.',
        buttons: ['OK'],
      });

      alert.present();
    }
    })

    


  } catch (error) {
    console.error(error);
  }
}


}





// WEBPACK FOOTER //
// ./src/components/compie/compie.ts